var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 2.95C1.5 2.52996 1.5 2.31994 1.58175 2.15951C1.65365 2.01839 1.76839 1.90365 1.90951 1.83175C2.06994 1.75 2.27996 1.75 2.7 1.75H15.3C15.72 1.75 15.9301 1.75 16.0905 1.83175C16.2316 1.90365 16.3463 2.01839 16.4183 2.15951C16.5 2.31994 16.5 2.52996 16.5 2.95V3.45205C16.5 3.65364 16.5 3.75444 16.4754 3.84817C16.4535 3.93123 16.4176 4.00993 16.3691 4.08082C16.3144 4.16082 16.2383 4.22684 16.0859 4.35887L11.2891 8.51613C11.1367 8.64816 11.0606 8.71418 11.0059 8.79418C10.9574 8.86507 10.9215 8.94377 10.8996 9.02683C10.875 9.12056 10.875 9.22136 10.875 9.42295V13.3438C10.875 13.4905 10.875 13.5638 10.8513 13.6272C10.8304 13.6832 10.7964 13.7334 10.7522 13.7736C10.7021 13.8192 10.634 13.8464 10.4978 13.9009L7.94783 14.9209C7.67218 15.0311 7.53435 15.0863 7.4237 15.0633C7.32695 15.0432 7.24204 14.9857 7.18744 14.9033C7.125 14.8091 7.125 14.6607 7.125 14.3638V9.42295C7.125 9.22136 7.125 9.12056 7.10037 9.02683C7.07854 8.94377 7.0426 8.86507 6.99413 8.79418C6.93943 8.71418 6.86326 8.64816 6.71092 8.51613L1.91408 4.35887C1.76174 4.22684 1.68557 4.16082 1.63087 4.08082C1.5824 4.00993 1.54646 3.93123 1.52463 3.84817C1.5 3.75444 1.5 3.65364 1.5 3.45205V2.95Z",
    fill: "#C2F764",
    stroke: "#24352F",
    strokeWidth: 1.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.6786abb4.svg";
export { ForwardRef as ReactComponent };